import { Component, Input, ViewChild } from "@angular/core";

import { OnInit } from "@angular/core";

import { DashboardService } from "../../services/dashboard.services";
import { MedicineService } from "../../services/medicine.services";
import { ActivatedRoute, Router } from "@angular/router";
import { GlobalCfgService } from '../../services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { MatOption } from '@angular/material';
import { startWith, map } from 'rxjs/operators';
import { LayoutDirective } from "@angular/flex-layout";
import { MiscService } from 'src/services/misc.service';
import { GeoFenceService } from 'src/services/geofence.service';
@Component({
  selector: "rm-incidents",
  templateUrl: "./incidents.component.html",
  styleUrls: ["./incidents.component.css"]
})
export class IncidentsComponent implements OnInit {
  @Input()
  hideToolbar: boolean = false;

  @Input()
  productId: string;

  @Input()
  gcp: string;

  @Input()
  batchNum: string;

  @Input()
  gln: string;

  // @Input()
  // showhidefences: string;

  selectedView: string = "geochart";
  
  searchTxt: string = "";
  incidents = [];
  google: any;
  gmap: any;
  selectedProduct: string = "all";
  products: any[] = [];
  eventsTypes: any[] = [];
  batchOverlays: any[] = [];
  selectedEventType: any = ["all","NORMAL","EXPIRED","OVERCOOLED","OVERHEATED","BATCHRECALLED","GEOFENCED","NOTSTANDARDQUALITY","HIGHHUMIDITY","LESSHUMIDITY","FAKE","NOTFORSALE","ALREADYSOLD","PRESCRIPTIONONLY","INVALIDLABEL"];
  @ViewChild('allSelected', { static: false }) allSelected: MatOption;

  regionHeader = [["Country", "Incidents"]];
  regionEventResponse: any;
  regionEventData: any;
  filteredFences : boolean = false;
  level: string = "country";
  subscriptions: any = [];
  labels: any;
  role: any;
  showingFenceData:boolean = false;
  allBatchFences: any[] =[];
  batchFences: any[] = [];
  map: any;
  constructor(
    private miscService: MiscService,
    private dashboardService: DashboardService,
    private medicineService: MedicineService,
    private route: ActivatedRoute,
    private router: Router,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService,
    private geofenceservice:GeoFenceService
  ) {}

  ngOnInit() {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
      this.labels = this.globalCfgService.getSettingValue('labels');
    }

    // var options = {
    //   center: { lat: 51.476852, lng: -0.0005 },
    //   zoom: 2,
    //   mapId: '32c64ca2d80e5193'
    // };

    // this.gmap = new this.google.maps.Map(
    //   document.getElementById("rm_map_div"),
    //   options
    // );
    if (this.productId) {
      this.selectedProduct = this.productId;
    }

    this.subscriptions.push(
      this.route.url.subscribe(url => {
        this.route.queryParamMap.subscribe(val => {
          var view = val.get("view");
          view = view || 'geochart';
          this.selectedView = view;
        });
      })
    );

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load();
      }
    ));

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
      if (this.role == "distributor") {
        this.selectedView = "grid";
      }
    });

    this.load();
  }

  load() {
    this.loadProducts();
    this.loadEventTypes();
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadProducts() {
    this.medicineService.getList(this.gcp).subscribe((response: any) => {
      this.products = response;
    });
  }

  loadEventTypes() {
    this.dashboardService.incidentType().subscribe((response: any) => {
      this.eventsTypes = response;
    });
  }

  applyFilter() {}

  clear() {
    this.searchTxt = "";
    this.batchNum = this.searchTxt;
  }

  changeView(e) {
    console.log('Event: ', e.value);
  
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        view: e.value 
      },
      queryParamsHandling: 'merge'
    });
  }

  togglePerOne(all){ 
    if (this.allSelected.selected) {  
     this.allSelected.deselect();
     return false;
    }
    if(this.selectedEventType.length==this.eventsTypes.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection() {
   if (this.allSelected.selected) {
      this.selectedEventType = [];
      this.selectedEventType.push("all");
      this.eventsTypes.forEach(element => {
        this.selectedEventType.push(element.value)
      });
    } else {
      this.selectedEventType = [];
    }
  }

  ShowFences(){
    this.filteredFences = true;
  }

  hideFencesButton(){
    this.filteredFences = false;
  }

  showAllFences() {
    this.filteredFences = true;
    this.showingFenceData = true;
    this.miscService.getIncidentsShowHideFencesdata(this.gcp).subscribe((response: any) => {
      this.allBatchFences = response.data;
    })
  }
  
  hideAllFences() {
    this.showingFenceData = false;
  }
}
